var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightRoundedBorders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "kgew0g4qya"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30ACC1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3077C1",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1.92C6.442 1.92 1.92 6.442 1.92 12S6.442 22.08 12 22.08 22.08 17.558 22.08 12 17.558 1.92 12 1.92zm4.406 9.551a.945.945 0 0 1 .065.121l.022.054a.944.944 0 0 1 .035.112l.014.065a1.13 1.13 0 0 1 .014.118l.001.03v.028a1.006 1.006 0 0 1-.029.243l-.011.041a.916.916 0 0 1-.024.07l-.022.055a.951.951 0 0 1-.064.12l-.013.02a.929.929 0 0 1-.05.071l-.018.021-2.5 3a1 1 0 1 1-1.537-1.28l1.135-1.364-6.792.01a1 1 0 0 1-.007-2l6.794-.01-1.13-1.356a1 1 0 0 1 1.537-1.28l2.5 3 .017.02.025.034-.027-.034.054.072.011.019z",
    fill: "",
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRoundedBorders);
export default __webpack_public_path__ + "static/media/arrow-right-rounded-borders.53c37568ddad13c0c4ad3543e63e1cd7.svg";
export { ForwardRef as ReactComponent };